import { Link } from 'react-router'

const ErrorBoundary = () => (
  <div className="flex h-full w-full flex-col bg-white pt-16 pb-12">
    <main className="mx-auto flex w-full max-w-7xl grow flex-col justify-center px-4 sm:px-6 lg:px-8">
      <div className="py-16">
        <div className="text-center">
          <h1>Something went wrong</h1>
          <div className="mt-6">
            <Link to="/" className="text-primary text-base font-medium hover:underline">
              Go back home
            </Link>
          </div>
        </div>
      </div>
    </main>
  </div>
)

export default ErrorBoundary
